const shouldUseXApiKey = (url: string): boolean => {
  const protectedEndpoints = ['/api-auth/discovery']

  try {
    const urlPath = new URL(url).pathname
    return protectedEndpoints.some((endpoint) => urlPath.includes(endpoint))
  } catch (error) {
    console.error('Error parsing URL:', error)
    return false
  }
}

export const applyXApiKeyToRequest = (url: string, config: any) => {
  if (!shouldUseXApiKey(url)) {
    return config
  }

  try {
    config.headers = {
      ...config.headers,
      'x-api-key': process.env.REACT_APP_X_API_KEY_DISCOVERY || ''
    }
  } catch (error) {
    console.error('Error applying x-api-key to request:', error)
  }

  return config
}
